import { useState } from "react";

// Stripe returns the buyer to /a/:token?checkout=success|cancel (Anvil's
// contract). MVP: success → receipt/ship message (no client status lookup —
// Stripe emails the receipt; a web order-status page is the PRD fast-follow).
// cancel → dismiss, no charge.
const initial = new URLSearchParams(window.location.search).get("checkout");

export function CheckoutBanner() {
  const [status, setStatus] = useState<string | null>(initial);
  if (status !== "success" && status !== "cancel") return null;
  const success = status === "success";

  function close() {
    setStatus(null);
    // Clean the query so a refresh doesn't re-show the banner.
    const url = new URL(window.location.href);
    url.searchParams.delete("checkout");
    url.searchParams.delete("session_id");
    window.history.replaceState({}, "", url.pathname + url.search + url.hash);
  }

  return (
    <div
      className={`checkout-banner ${success ? "is-success" : "is-cancel"}`}
      role="status"
    >
      <span className="checkout-banner__text">
        {success
          ? "Order placed — Stripe emailed your receipt. Your book prints and ships in a few days."
          : "Checkout canceled — you haven’t been charged."}
      </span>
      <button
        type="button"
        className="checkout-banner__close"
        onClick={close}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
